import React from 'react';
import { Typography, Divider } from '@mui/material';
import GlobalSearcher from '../../../../../../../../../lib/common/GlobalSearcher';
import EnhancedTable from '../../../../../../../../../lib/designSystem/Table';
import OperationResume from '../OperationResume';

const DocumentSelector = (props: any) => {
  const {
    business,
    productType,
    filteredDocuments,
    selected,
    setSelected,
    filters,
    filterDocuments,
  } = props;
  return (
    <div>
      <OperationResume
        stakeholderName={business.businessName}
        stakeholderIdentifier={business.identifier}
        productType={productType}
      />
      <Divider />
      <div style={{ padding: '20px 0px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>
            <Typography variant="h6" gutterBottom>
              Documentos disponibles
            </Typography>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <GlobalSearcher
              filters={filters}
              triggerSearch={() => filterDocuments()}
            />
            {/* TODO: */}
            {/* <CustomButton
            variant="contained"
            color="primary"
            onClick={() => handleOpenDialogAdder()}
          >
            {' '}
            Agregar documentos
          </CustomButton> */}
          </div>
        </div>
        <div>
          <Typography>{selected.length} documentos seleccionados.</Typography>
        </div>
        <div>
          <EnhancedTable
            dataHeaders={[
              { key: 'folio', label: 'Folio' },
              { key: 'amount', label: 'Monto', type: 'money' },
              {
                key: 'amountAvailable',
                label: 'Monto disponible',
                type: 'money',
              },
              {
                key: 'businessName',
                label: 'Proveedor',
              },
              {
                key: 'issuedDate',
                label: 'Fecha de emisión',
                type: 'date',
              },
              {
                key: 'confirmDate',
                label: 'Fecha de confirmación',
                type: 'date',
              },
            ]}
            data={filteredDocuments}
            selected={selected}
            setSelected={setSelected}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentSelector;
